import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getCurrentUser } from "../../services/auth_service";
import { useAuth } from "../../services/authProvider";

const HCP_ROLES = ["HEALTH_CARE_PROVIDER", "CLINICAL_LOCATION_ADMIN"];

const RoleProtectedRoute = ({ path, component: Component, allowedRoles, render, ...rest }) => {
  const { accessToken } = useAuth();

  const getUserRole = () => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      if (!user || !user?.organizations || !user?.organizations[0]) {
        return null;
      }

      const role = user.roles?.filter((r)=> r.active === true)[0]?.role;
      return role;
    } catch (ex) {
      console.error('Error getting user role:', ex);
      return null;
    }
  };

  const isProfileComplete = () => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      const userId = user?.id;
      if (!userId) return true;
      return localStorage.getItem(`profileComplete_${userId}`) === 'true';
    } catch {
      return true;
    }
  };

  return (
    <Route
      {...rest}
      render={(props) => {
        // Check if user is authenticated
        if (!accessToken || !getCurrentUser()) {
          return (
            <Redirect
              to={{ pathname: "/user/login", state: { from: props.location } }}
            />
          );
        }

        // Check if user has the required role
        const userRole = getUserRole();

        if (!userRole) {
          return (
            <Redirect
              to={{ pathname: "/user/role", state: { from: props.location } }}
            />
          );
        }

        // Check if the user's role is in the allowed roles list
        if (allowedRoles && !allowedRoles.includes(userRole)) {
          return (
            <Redirect
              to={{ pathname: "/unauthorized", state: { from: props.location } }}
            />
          );
        }

        // For HCP roles, enforce profile completion before allowing access
        if (allowedRoles?.some((r) => HCP_ROLES.includes(r)) && !isProfileComplete()) {
          return (
            <Redirect to="/hcp/first_login_profile/personal_details" />
          );
        }

        // User is authenticated and has the correct role
        return Component ? <Component {...props} /> : render(props);
      }}
    />
  );
};

export default RoleProtectedRoute;
